/* Native carousels and media dialogs. Safe for theme-editor reloads and inline Custom Liquid. */
(() => {
  if (customElements.get('folessa-sections')) return;
  class FolessaSections extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.booting) return;
      this.booting = true;
      const boot = () => {
        this.booting = false;
        if (this.isConnected) this.initialize();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, {once:true});
      } else {
        queueMicrotask(boot);
      }
    }
    initialize() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.observers = [];
      this.querySelectorAll('[data-flx-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-flx-track]');
        if (!track) return;
        const slides = Array.from(track.children);
        const prev = carousel.querySelector('[data-flx-prev]');
        const next = carousel.querySelector('[data-flx-next]');
        const dots = carousel.querySelector('[data-flx-dots]');
        const status = carousel.querySelector('[data-flx-status]');
        let stops = [], index = 0, raf = 0;
        const update = () => {
          if (!stops.length) return;
          const x = track.scrollLeft;
          index = stops.reduce((best, stop, n) => Math.abs(stop - x) < Math.abs(stops[best] - x) ? n : best, 0);
          if (prev) prev.disabled = index === 0;
          if (next) next.disabled = index === stops.length - 1;
          if (dots) Array.from(dots.children).forEach((dot, n) => dot.setAttribute('aria-current', String(n === index)));
          if (status) status.textContent = `Position ${index + 1} of ${stops.length}`;
        };
        const move = n => {
          const i = Math.max(0, Math.min(stops.length - 1, n));
          track.scrollTo({left: stops[i] || 0, behavior: reduced() ? 'auto' : 'smooth'});
        };
        const measure = () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          const start = slides[0]?.offsetLeft || 0;
          stops = slides.map(slide => Math.min(max, Math.max(0, slide.offsetLeft - start)))
            .filter((value, n, values) => n === 0 || Math.abs(value - values[n - 1]) > 2);
          if (dots) {
            dots.replaceChildren();
            stops.forEach((_, n) => {
              const dot = document.createElement('button');
              dot.type = 'button'; dot.className = 'flx-dot';
              dot.setAttribute('aria-label', `Go to carousel position ${n + 1}`);
              dot.setAttribute('aria-current', String(n === index));
              dot.innerHTML = '<span aria-hidden="true"></span>';
              dot.addEventListener('click', () => move(n), {signal});
              dots.append(dot);
            });
            dots.hidden = stops.length < 2;
          }
          update();
        };
        prev?.addEventListener('click', () => move(index - 1), {signal});
        next?.addEventListener('click', () => move(index + 1), {signal});
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf); raf = requestAnimationFrame(update);
        }, {signal, passive:true});
        track.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          if (event.target !== track) return;
          event.preventDefault();
          move(event.key === 'Home' ? 0 : event.key === 'End' ? stops.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        const observer = new ResizeObserver(measure);
        observer.observe(track); this.observers.push(observer);
        slides.forEach(slide => slide.querySelectorAll('img').forEach(img => img.addEventListener('load', measure, {signal, once:true})));
        measure();
      });
      this.querySelectorAll('[data-flx-buy]').forEach(link => link.addEventListener('click', event => {
        const form = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(el => el.getClientRects().length && !el.closest('dialog,cart-drawer,.quick-add-modal'));
        const target = form?.closest('[id^="ProductInfo-"]') || form;
        if (!target) return;
        event.preventDefault();
        const y = target.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({top:Math.max(0,y),behavior:reduced()?'auto':'smooth'});
      }, {signal}));
      const dialog = this.querySelector('[data-flx-modal]');
      if (dialog) {
        const video = dialog.querySelector('video');
        const title = dialog.querySelector('[data-flx-modal-title]');
        let trigger = null;
        const close = () => dialog.close();
        dialog.querySelector('[data-flx-close]')?.addEventListener('click',close,{signal});
        dialog.addEventListener('click',e => { if(e.target === dialog) close(); },{signal});
        dialog.addEventListener('close',() => {
          video.pause(); video.removeAttribute('src'); video.load(); trigger?.focus();
        },{signal});
        this.querySelectorAll('[data-flx-video]').forEach(button => button.addEventListener('click',() => {
          trigger = button;
          title.textContent = button.dataset.flxTitle || 'Supplied demonstration footage';
          video.src = button.dataset.flxVideo;
          dialog.showModal();
          video.play().catch(() => {});
        },{signal}));
      }
      this.querySelector('[data-flx-more]')?.addEventListener('click',event => {
        this.querySelectorAll('[data-flx-extra-review]').forEach(card => {card.hidden=false;});
        event.currentTarget.hidden=true;
      },{signal});
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller=null;
      this.observers?.forEach(observer => observer.disconnect());
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  }
  customElements.define('folessa-sections',FolessaSections);
})();
